module.exports = __webpack_public_path__ + "static/img/complispace-logo.56d2f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/complispace-logo.png
// module id = FHiC
// module chunks = 1